import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {useState} from 'react'
import MuiPhoneNumber from 'material-ui-phone-number'
import {create_user} from '../SuperAdminUser_Api'
import Swal from 'sweetalert2'

const modalsRoot = document.getElementById('root-modals') || document.body
const AddUserInitialValues = {
  email_id: '',
  contact_number: '',
  accouont_holder_name: '',
}
const AddUserValidationSchema = Yup.object({
  email_id: Yup.string().required('Email address is required').email('Wrong email format'),
  contact_number: Yup.string().required('Contact number is required'),
  accouont_holder_name: Yup.string().required('User name is required'),
})

interface addUserModalDataType {
  showAddUserModal: boolean
  handleClose: () => void
  setItemOffset: (itemOffset: number) => void
  setCurrentPage: (currentPage: number) => void
  getUser: () => void
}
const AddUserModal = ({
  showAddUserModal,
  handleClose,
  setItemOffset,
  setCurrentPage,
  getUser,
}: addUserModalDataType) => {
  const [loading, setLoading] = useState<boolean>(false)

  // formik values for add user
  const formik = useFormik({
    initialValues: AddUserInitialValues,
    validationSchema: AddUserValidationSchema,
    onSubmit: (values) => createUser(values),
  })

  // function to create_user
  const createUser = async (values: any) => {
    setLoading(true)
    try {
      const {data: response} = await create_user(
        values.email_id,
        values.contact_number,
        values.accouont_holder_name
      )
      if (response.code === '200') {
        setItemOffset(0)
        setCurrentPage(1)
        getUser()
        handleClose()
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
        allowOutsideClick: true,
      })
    } finally {
      setLoading(false)
    }
  }
  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-700px'
      show={showAddUserModal}
      onHide={handleClose}
      backdrop={true}
    >
      {/* Begin: Modal header */}
      <div className='modal-header pt-5 pb-5'>
        {/* Begin: Modal Heading */}
        <h2>Add User</h2>
        {/* End: Modal Heading */}
        {/* Begin::Close button */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <i className='bi bi-x-lg' onClick={handleClose}></i>
        </div>
        {/* end::Close button */}
      </div>
      {/* End: Modal header */}

      {/* Begin: Modal body */}
      <div className='modal-body p-5'>
        {/*Begin::Stepper */}

        {/*Begin:: Form Content */}
        <div className='flex-row-fluid px-lg-10'>
          {/*Begin::Form */}
          <form
            onSubmit={formik.handleSubmit}
            id='kt_modal_create_app_form'
            className='pt-4 d-flex flex-column justify-content-center align-items-center'
          >
            {/*Begin::Actions */}
            <div className='w-100'>
              {/*Begin::Form Group property title */}
              <div className='fv-row'>
                <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                  <span className='required'>User Name</span>
                  <i
                    className='fas fa-exclamation-circle ms-2 fs-7'
                    data-bs-toggle='tooltip'
                    title='Specify user name'
                  ></i>
                </label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  {...formik.getFieldProps('accouont_holder_name')}
                  name='accouont_holder_name'
                  placeholder='Enter user name'
                />
                <div className='h-20px'>
                  {formik.touched.accouont_holder_name && formik.errors.accouont_holder_name && (
                    <div className='fv-help-block color-red'>
                      {formik.errors.accouont_holder_name}
                    </div>
                  )}
                </div>
              </div>
              {/*End::Form Group property title */}
              {/*Begin::Form Group property title */}
              <div className='fv-row'>
                <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                  <span className='required'>Email ID</span>
                  <i
                    className='fas fa-exclamation-circle ms-2 fs-7'
                    data-bs-toggle='tooltip'
                    title='Specify your email address'
                  ></i>
                </label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  {...formik.getFieldProps('email_id')}
                  name='email_id'
                  placeholder='Enter email address'
                />
                <div className='h-20px'>
                  {formik.touched.email_id && formik.errors.email_id && (
                    <div className='fv-help-block color-red'>{formik.errors.email_id}</div>
                  )}
                </div>
              </div>
              {/*End::Form Group property title */}
              {/*Begin::Form Group Phone Number*/}
              <div className='fv-row mb-3'>
                <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                  <span className='required'>Phone Number</span>
                  <i
                    className='fas fa-exclamation-circle ms-2 fs-7'
                    data-bs-toggle='tooltip'
                    title='Enter phone number'
                  ></i>
                </label>
                <MuiPhoneNumber
                  onChange={(value) => formik.setFieldValue('contact_number', value)}
                  className='w-100'
                  defaultCountry={'in'}
                />
                <div className='h-20px'>
                  {formik.touched.contact_number && formik.errors.contact_number && (
                    <div className='fv-help-block color-red'>{formik.errors.contact_number}</div>
                  )}
                </div>
              </div>
              {/*End::Form Group Phone Number*/}
            </div>
            {/* Begin:: submit button */}
            <button
              type='submit'
              className='btn btn-lg btn-primary'
              data-kt-stepper-action='submit'
              disabled={loading}
            >
              {loading ? (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Processing...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              ) : (
                'Submit'
              )}
            </button>
            {/* Begin:: submit button */}

            {/* Begin:: Submit and next button div */}

            {/*end::Actions */}
          </form>
          {/*end::Form */}
        </div>
        {/*end:: Form Content */}

        {/* end::Stepper */}
      </div>
      {/* End: Modal body */}
    </Modal>,
    modalsRoot
  )
}

export default AddUserModal
